import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-tai-chi-walking&exp=web_tai_chi_walking_walk_at_loader~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_walking_walk_at_loader'),
			},
		},
	},
]

export default config
